const dashify = (str: string): string => str.trim().replace(/\s+/g, "-").toLowerCase();

export { dashify };
